import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';

class RatingForm extends Component {
	constructor(props) {
		super(props);
		
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	
	handleChange(e) {
		e.preventDefault();
		const {name, value} = e.target;
		let rating = {
			grammarortog: this.props.grammarortog,
			localization: this.props.localization,
			style: this.props.style
		}
		rating[name]=value;
		this.props.update(rating);
	}
	
	handleSubmit(e) {
		e.preventDefault();
		this.props.save();
	}
	
	
	render() {
		return (
			<div className="contentM">
			<h1>Rating</h1>
			<form className="form-inline">
			<div className="col-12" align="center">
				<div className="row"><div className="col-1">orthogrammatic:</div><div className="col-1"><input type="text" id="grammarortog" name="grammarortog" minlength="1" maxlength="2" size="2" onChange={this.handleChange} value={this.props.grammarortog}/></div></div>
				<div className="row"><div className="col-1">localization:</div><div className="col-1"><input type="text" id="localization" name="localization" minlength="1" maxlength="2" size="2" onChange={this.handleChange} value={this.props.localization}/></div></div>
				<div className="row"><div className="col-1">style:</div><div className="col-1"><input type="text" id="style" name="style" minlength="1" maxlength="2" size="2" onChange={this.handleChange} value={this.props.style}/></div></div>
				<div className="row"><div className="col-2" align="center"><Button onClick={this.handleSubmit} variant="contained" color="primary" aria-label="Save">Save</Button></div></div>
			</div>
			</form>
			</div>
		);
	}
}

export default RatingForm;